import { render, staticRenderFns } from "./TalentFindReadinessDashboard.vue?vue&type=template&id=68a9898a&scoped=true"
import script from "./TalentFindReadinessDashboard.vue?vue&type=script&lang=js"
export * from "./TalentFindReadinessDashboard.vue?vue&type=script&lang=js"
import style0 from "./TalentFindReadinessDashboard.vue?vue&type=style&index=0&id=68a9898a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a9898a",
  null
  
)

export default component.exports